var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTamanhoG = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M64.305 50.873V20.317h18.437v-5.688c0-3.109-2.565-5.629-5.73-5.629H49.31c-3.164 0-5.73 2.52-5.73 5.63v40.204h45.498v-1.26c0-1.492-1.231-2.702-2.75-2.702H64.305v.001Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M82.743 21.026v3H72.376v-3"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M82.743 21.026v3H72.376v-3"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M79.864 24.776v4.062h-4.608v-4.062"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M79.864 24.776v4.062h-4.608v-4.062"
  }), React.createElement("path", {
    fill: color,
    d: "m45.247 10.677-1.5 3-.247 2.25h39.247v-1.5l-.75-2.25-1.5-2.25-3-.75h-29.25l-3 1.5Z"
  }), React.createElement("path", {
    fill: "#F0E6FF",
    d: "M86.306 41.428c.942-.31 1.974-.244 2.556.313.903.865.69 2.555-.886 3.33-1.657.813-3.38.542-4.484 1.627"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M86.306 41.428c.942-.31 1.974-.244 2.556.313.903.865.69 2.555-.886 3.33-1.657.813-3.38.542-4.484 1.627"
  }), React.createElement("path", {
    fill: color,
    d: "m83.018 50.497-2.142-1.833c3.406-1.483 5.808-6.384 5.808-10.569v-.011H68.059v.011c0 4.184 2.4 9.086 5.807 10.57l-2.142 1.832"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m83.018 50.497-2.142-1.833c3.406-1.483 5.808-6.384 5.808-10.569v-.011H68.059v.011c0 4.184 2.4 9.086 5.807 10.57l-2.142 1.832"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M47.667 23.322h6.997M47.666 27.906h6.998M47.666 32.49h6.998M43.586 15.874h39.068M63.75 54.834h25.327v-1.26c0-1.492-1.231-2.702-2.75-2.702l-22.022.001V20.317h18.437v-5.688c0-3.109-2.565-5.629-5.73-5.629H49.31c-3.164 0-5.73 2.52-5.73 5.63v17.62"
  }), React.createElement("path", {
    fill: color,
    d: "M20.685 75.695h-8.67c-1.957 0-3.548-1.614-3.548-3.6V53.157c0-1.987 1.59-3.6 3.549-3.6h44.43c1.958 0 3.549 1.613 3.549 3.6v18.931c0 1.987-1.591 3.6-3.55 3.6h-8.669"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M20.685 75.695h-8.67c-1.957 0-3.548-1.614-3.548-3.6V53.157c0-1.987 1.59-3.6 3.549-3.6h44.43c1.958 0 3.549 1.613 3.549 3.6v18.931c0 1.987-1.591 3.6-3.55 3.6h-8.669"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M47.286 68.991H21.168a.487.487 0 0 0-.483.49v13.763c0 .27.216.49.483.49h26.118c.267 0 .483-.22.483-.49V69.48c0-.27-.216-.49-.483-.49Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M21 48.75V36.167c0-.255.218-.467.494-.467h26.012c.27 0 .494.206.494.467V48.75"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21 48.75V36.167c0-.255.218-.467.494-.467h26.012c.27 0 .494.206.494.467V48.75"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.731 55.588h36.997M44.137 61.62h2.647M50.088 61.62h2.64"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M21.019 49.556H15.75l-.019-3.268c0-1.157.921-2.098 2.068-2.098h3.22"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21.019 49.556V44.19h-3.22c-1.147 0-2.068.941-2.068 2.098l.019 3.268h5.269Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-80)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M25.645 73.683h17.171M25.645 77.708H36.87"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M48.596 49.527h4.79v-3.239c0-1.157-.92-2.098-2.067-2.098h-2.723"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.596 49.527h4.79v-3.239c0-1.157-.92-2.098-2.067-2.098h-2.723"
  }));
};
export default SvgTamanhoG;